export default "__VITE_ASSET__Tc1pu3pI__"